import type { ComponentChildren } from 'preact';

interface LcarsPanelProps {
  color: string;
  title: string;
  badge?: string;
  action?: { label: string; onClick: () => void };
  children: ComponentChildren;
}

export function LcarsPanel({ color, title, badge, action, children }: LcarsPanelProps) {
  return (
    <div class="lcars-panel">
      <div class="panel-chrome">
        <div class="panel-pill" style={{ background: color }}></div>
        <div class="panel-bar" style={{ background: color }}>
          <span class="panel-title">{title}</span>
          {badge && <span class="panel-badge">{badge}</span>}
          {action && (
            <button class="panel-action" onClick={action.onClick}>
              {action.label}
            </button>
          )}
        </div>
      </div>
      <div class="panel-content">
        {children}
      </div>
    </div>
  );
}
